import { CredentialLayout } from "../CredentialLayout";
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";
import { Component } from "react";

interface TokenAuthViewPageProps extends NSARouterMakerResult, CredentialProps { }

class TokenAuthViewPage extends Component<TokenAuthViewPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section shows the full details of a Token Auth credential, including its name and the API token it stores as a secret. You can review its history and tags and copy any field, while the secret value stays protected."
                }}
                pages={{
                    entity: CredentialEntities.token_auth(this.props),
                    view: {}
                }}
            >
                <></>
            </CredentialLayout>
        );
    }
}

export default TokenAuthViewPage;